import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import { ResourceCollection } from "@/modules/api/resource.collection";

import FactoryProductDepositSetting from "./factory-product-deposit-setting.model";

export default class FactoryProductDepositSettingRepository extends BasicRepository<FactoryProductDepositSetting> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<FactoryProductDepositSetting>,
    responseParser: ApiCollectionResponseParserService<FactoryProductDepositSetting>
  ) {
    super(
      "factory_product_deposit_settings",
      api,
      objectBuilder,
      responseParser
    );
  }

  public getByFactoryId(
    factoryId: string,
    isDisablePagination = false,
    useCache = true
  ): Promise<ResourceCollection<FactoryProductDepositSetting>> {
    return this.fetchList(
      { factoryId },
      1,
      isDisablePagination ? BasicRepository.MAX_ITEMS_PER_PAGE : undefined,
      undefined,
      useCache
    );
  }

  public async updateForFactory(
    factoryId: string,
    items: FactoryProductDepositSetting[]
  ): Promise<FactoryProductDepositSetting[]> {
    const response = await this.api.post(
      `${this.resourceName}/update_requests`,
      { factoryId, items: items.map((item) => this.prepareData(item)) }
    );
    return this.responseParser
      .parse(response.data, this.objectBuilder)
      .getItems();
  }

  protected prepareData(
    item: FactoryProductDepositSetting
  ): Record<string, number> {
    return {
      productId: Number(item.productId),
      depositPercent: item.depositPercent,
    };
  }
}
